import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_TOAST_MESSAGE,
} from '../../../../../helpers/EventEmitter'
import { getCartQuantity } from '../../../../../layout/store/thunk'
import Service from './Service'

export const addToCart = createAsyncThunk(
  'companyAnalysis/order/cart/addToCart',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await Service.addToCart(params)

      if (res.success) {
        dispatch(getCartQuantity())
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: (
            <Translate value="common.toastMessage.ADD_TO_CART_SUCCESSFULLY" />
          ),
        })
        return res.data
      }

      return rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({
        isLoading: axios.isCancel(error),
        codeErr: error?.response?.status,
      })
    }
  },
)

export const getLastPurchaseDate = createAsyncThunk(
  'companyAnalysis/order/cart/getLastPurchaseDate',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.getLastPurchaseDate(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
